import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
@Component({
  selector: 'cm-publisher-request-new-domain-dialog',
  template: `
    <h1 mat-dialog-title>Add new domain for current unit</h1>
    <div mat-dialog-content>
      <mat-form-field class="w-100 mb-3">
        <form #form="ngForm">
          <input matInput
                 #url="ngModel"
                 required
                 name="url"
                 placeholder="Enter domain url..."
                 [pattern]="regex"
                 (keyup.enter)="form.valid && submit()" [(ngModel)]="domain">
        </form>
        <mat-error>
          <div [hidden]="!url.errors || !url.errors.pattern">
            Must be a valid URL!
          </div>
        </mat-error>
        <mat-hint>Example: www.google.com</mat-hint>
      </mat-form-field>
    </div>
    <div mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="submit()">Submit</button>
    </div>
  `,
})
export class PublisherRequestNewDomainDialogComponent {

  public domain = '';
  public regex = new RegExp('^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}$')

  constructor(public dialogRef: MatDialogRef<PublisherRequestNewDomainDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  submit() {
    this.dialogRef.close(this.domain);
  }

}
